import { computed } from 'vue';
import { useGetPageField } from './useGetPageField';
import { createBackgroundStyle } from '../utils/styleUtils';
import { PUI, RegistryId } from '@pleased-npm/fe-customisation';

interface UsePageBodyStyleOptions {
  registryId: RegistryId;
  sectionKey: string;
  blockKey: string;
}

/**
 * Composable to get page body background style
 * Centralizes the pattern for getting body background color and creating content style
 */
export const usePageBodyStyle = (options: UsePageBodyStyleOptions) => {
  const bodyBackgroundColor = useGetPageField({
    registryId: options.registryId,
    fieldKey: PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR,
    sectionKey: options.sectionKey,
    blockKey: options.blockKey,
  });

  const contentStyle = computed(() => createBackgroundStyle(bodyBackgroundColor));

  return {
    contentStyle,
  };
};
